import { render, staticRenderFns } from "./editor_elaborate.vue?vue&type=template&id=f9b186ba"
import script from "./editor_elaborate.vue?vue&type=script&lang=js"
export * from "./editor_elaborate.vue?vue&type=script&lang=js"
import style0 from "./editor_elaborate.vue?vue&type=style&index=0&id=f9b186ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports